/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supported_Format_CcprjInputs */



/**
* | output |
* | --- |
* | "Supported format: .ccprj" |
*
* @param {Supported_Format_CcprjInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const supported_format_ccprj = /** @type {((inputs?: Supported_Format_CcprjInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supported_Format_CcprjInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format pris en charge : .ccprj")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstütztes Format: .ccprj")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato supportato: .ccprj")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поддерживаемый формат: .ccprj")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato admitido: .ccprj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("支持的格式：.ccprj")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サポートされている形式: .ccprj")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समर्थित प्रारूप: .ccprj")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato suportado: .ccprj")
	return /** @type {LocalizedString} */ ("Supported format: .ccprj")
});